import { MDSDropdown } from '@marqvision/mds-v2';
import { useQueryParams } from '@marqvision/shared';
import { useTestPurchaseProgressFilterQuery } from '~/apis/websiteContent';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useLogger } from '~/hooks';
import { FilterQueryParams as WebsiteContentFilterQueryParams } from '~/pages/WebsiteContent/_impersonation/@types';
import { useRequest as useWebsiteContentRequest } from '~/pages/WebsiteContent/_impersonation/List/@hooks/useRequest';
import { MarqCommonEnumsTpTpProgressStatusEnum } from '~/swagger/data-contracts';
import { parseDropDown, parseValueToValueArray } from '~/utils';
import { FILTER_LABEL, FILTER_LOG_LABELS } from './DynamicFilter/@constants';
import { ChannelGroup, FilterTypeEnum } from './DynamicFilter/@types';

interface Props extends ResponsiveProps {
  channel?: ChannelGroup;
  logPage?: string;
}

export const WebsiteContentTestPurchaseProgressFilter = (props: Props) => {
  const { size = 'medium', channel = 'website content', logPage } = props;
  const { amplitudeLogging } = useLogger();

  const isDomainNames = channel === 'domain names';

  const { stringParams: websiteContentParams, setParams: setWebsiteContentParams } =
    useQueryParams<WebsiteContentFilterQueryParams>();
  const { request } = useWebsiteContentRequest();

  const websiteContentQuery = useTestPurchaseProgressFilterQuery(
    { ...request, tp_progress_status_filter: undefined },
    {
      select: parseDropDown<MarqCommonEnumsTpTpProgressStatusEnum>,
      enabled: !isDomainNames,
    }
  );

  const params = websiteContentParams;
  const setParams = setWebsiteContentParams;

  const data = websiteContentQuery.data;
  const list = data?.list || [];
  const selected = params.tp_progress_status_filter ? parseValueToValueArray(params.tp_progress_status_filter) : [];
  const isLoading = websiteContentQuery.isLoading;
  const isDisabled = !list.length;

  const handleChange = (value: MarqCommonEnumsTpTpProgressStatusEnum[]) => {
    setParams({ tp_progress_status_filter: value });

    if (value.length > 0) {
      amplitudeLogging('applied filter', {
        Type: FILTER_LOG_LABELS[FilterTypeEnum.WEBSITE_CONTENT_TEST_PURCHASE_PROGRESS],
        Channel: channel,
        Page: logPage || (isDomainNames ? 'domain list' : 'website content list'),
      });
    }
  };

  return (
    <MDSDropdown
      label={FILTER_LABEL[FilterTypeEnum.WEBSITE_CONTENT_TEST_PURCHASE_PROGRESS]}
      modules={[
        'search',
        {
          type: 'filter-button',
          size,
        },
      ]}
      value={selected}
      list={list}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onChange={handleChange}
    />
  );
};
